import { render, staticRenderFns } from "./EditAccountBook.vue?vue&type=template&id=3dda6bd2&scoped=true&"
import script from "./EditAccountBook.vue?vue&type=script&lang=js&"
export * from "./EditAccountBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dda6bd2",
  null
  
)

export default component.exports